import React from 'react';
import styled from 'styled-components';
import { theme as UITheme } from 'affiny-ui/src/theme';
import Loader, { LoaderProps } from './loader';

type FullscreenLoaderProps = {
  hasOverlay?: boolean;
};

const LOADER_SIZE = 50;

const FullscreenLoader = (props: LoaderProps & FullscreenLoaderProps) => (
  <StyledLoader {...props} />
);

const StyledLoader = styled(Loader).attrs<LoaderProps, FullscreenLoaderProps>(
  () => ({
    size: LOADER_SIZE,
    hasOverlay: false,
  })
)`
  align-items: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${({ hasOverlay }) =>
    hasOverlay ? UITheme.colors.pc_darkTranslucent : 'none'};
`;

export default FullscreenLoader;
